<form [formGroup]="specBelastingBox1FormGroup">
    <div formGroupName="specificatieBelastingBox1">
        <div formGroupName="opbouw">
            <div>
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Box 1 - 1e schijf: {{ this.wetgevingFg.get("box1PercentageSchijf1")?.value | number: '1.0-2' }}% van
                        € {{ this.berekeningBox1FormGroup.get(['box1', 'inkomen1eSchijf'])?.value | number: '1.0-0'  }}
                    </div>
                    <div></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="totaalSchijf1EnSchijf2"
                                id="totaalSchijf1EnSchijf2"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div *ngIf="this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.schijf3 !== undefined &&  this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.schijf3! > 0">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Box 1 - 2e schijf: {{ this.wetgevingFg.get("box1PercentageSchijf2")?.value | number: '1.0-2' }}% van
                        € {{ this.berekeningBox1FormGroup.get(['box1', 'inkomen2eSchijf'])?.value | number: '1.0-0'  }}
                    </div>
                    <div></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="schijf3"
                                id="schijf3"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div *ngIf="this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.schijf4 !== undefined &&  this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.schijf4! > 0">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Box 1 - 3e schijf: {{ this.wetgevingFg.get("box1PercentageSchijf3")?.value | number: '1.0-2' }}% van
                        € {{ this.berekeningBox1FormGroup.get(['box1', 'inkomen3eSchijf'])?.value | number: '1.0-0'  }}
                    </div>
                    <div></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="schijf4"
                                id="schijf4"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div *ngIf="this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.tariefsaanpassingAftrekEigenWoning !== undefined &&  this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.tariefsaanpassingAftrekEigenWoning! > 0">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Tariefsaanpassing aftrekposten
                    </div>
                    <div></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="tariefsaanpassingAftrekEigenWoning"
                                id="tariefsaanpassingAftrekEigenWoning"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div *ngIf="this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.voorkomingVerrekenmethode !== undefined &&  this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.voorkomingVerrekenmethode! !== 0">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Af: voorkoming dubbele belasting (te verrekenen)
                    </div>
                    <div></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="voorkomingVerrekenmethode"
                                id="voorkomingVerrekenmethode"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div *ngIf="this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.voorkomingVrijstellingsmethode !== undefined &&  this.specBelastingBox1.specificatieBelastingBox1?.opbouw?.voorkomingVrijstellingsmethode! > 0">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Af: voorkoming dubbele belasting (vrijgesteld)
                    </div>
                    <div></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="voorkomingVrijstellingsmethode"
                                id="voorkomingVrijstellingsmethode"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
            <div>
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Belasting box 1
                    </div>
                    <div class="flex-item-ruimte-dialog"></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="totaalIB"
                                id="totaalIB"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>

        </div>
    </div>
</form>

